export const services = [
  {
    id: 1,
    iconClass: "icon-users",
    text: "Personalized Learning",
  },
  {
    id: 2,
    iconClass: "icon-pen",
    text: "Adaptive Learning Plans",
  },
  {
    id: 3,
    iconClass: "icon-blog",
    text: "Customized Courses",
  },
  {
    id: 4,
    iconClass: "icon-comment",
    text: "Real Time Translation",
  },
  {
    id: 5,
    iconClass: "icon-share",
    text: "Skill Assessment",
  },
  {
    id: 6,
    iconClass: "icon-chart-line",
    text: "Learning Insights",
  },
];

export const servicesItems = [
  {
    id: 1,
    iconClass: "icon-copy-writing-1",
    title: "Writing Blog Content",
    description: "We denounce righteous indigna <br /> and dislike men",
    link: "#",
  },
  {
    id: 2,
    iconClass: "icon-wishlist-1",
    title: "eCommerce Copy",
    description: "We denounce righteous indigna <br /> and dislike men",
    link: "#",
  },
  {
    id: 3,
    iconClass: "icon-internet-1",
    title: "Website Copy",
    description: "We denounce righteous indigna <br /> and dislike men",
    link: "#",
  },
  {
    id: 4,
    iconClass: "icon-megaphone-1",
    title: "Marketing Copy",
    description: "We denounce righteous indigna <br /> and dislike men",
    link: "#",
  },
  {
    id: 5,
    iconClass: "icon-network-1",
    title: "Social Media Content",
    description: "We denounce righteous indigna <br /> and dislike men",
    link: "#",
  },
  {
    id: 6,
    iconClass: "icon-network-2",
    title: "Digital Ad Copy",
    description: "We denounce righteous indigna <br /> and dislike men",
    link: "#",
  },
];
